module.exports = __webpack_public_path__ + "img/inventory-logo.b6c8e5e5.png";